import SectionContainer from "../components/SectionContainer";

// Note: Google for Startups requires direct LinkedIn links here, and each profile
// must list "Shadow" / "ShadowLabs" under its Experience section.
const TEAM = [
  {
    name: "Shubham Gupta",
    role: "CEO",
    subheader: "IIT Delhi · Ex-Sanas",
    photo: "/images/landing-v2/team/shubham.jpeg",
    linkedin: "https://www.linkedin.com/in/shubham16180/",
  },
  {
    name: "Mayank Gupta",
    role: "CTO",
    subheader: "IIT Roorkee · Ex-Vyapar",
    photo: "/images/landing-v2/team/mayank.jpeg",
    linkedin: "https://www.linkedin.com/in/mayank-gupta-pm/",
  },
  {
    name: "Hersh Singh",
    role: "GTM",
    subheader: "Ex-Sanas",
    photo: "/images/landing-v2/team/hersh.jpeg",
    linkedin: "https://www.linkedin.com/in/hersh-singh-944234166/",
  },
  {
    name: "Priyansh Agrawal",
    role: "Founding Engineer",
    subheader: "IIT Delhi · Ex-Samsung Research",
    photo: "/images/landing-v2/team/priyansh.jpeg",
    linkedin: "https://www.linkedin.com/in/priyansh-agrawal-72192b195/",
  },
];

function initials(name) {
  return name
    .split(" ")
    .map((part) => part[0])
    .slice(0, 2)
    .join("")
    .toUpperCase();
}

function TeamCard({ name, role, subheader, photo, linkedin }) {
  return (
    <div className="flex flex-col items-center rounded-3xl bg-[#F4F5F7] p-8 text-center transition-shadow hover:shadow-[0_12px_32px_rgba(15,23,42,0.08)]">
      <div className="relative h-32 w-32 overflow-hidden rounded-full bg-gradient-to-br from-teal-600 to-cyan-600 sm:h-36 sm:w-36">
        <span className="absolute inset-0 flex items-center justify-center text-xl font-semibold text-white">
          {initials(name)}
        </span>
        {photo ? (
          <img
            src={photo}
            alt={name}
            loading="lazy"
            className="relative h-full w-full object-cover"
            onError={(e) => {
              e.currentTarget.style.display = "none";
            }}
          />
        ) : null}
      </div>
      <h3 className="mt-5 text-lg font-semibold tracking-tight text-neutral-900">{name}</h3>
      <p className="mt-1 text-sm font-medium text-teal-700">{role}</p>
      <p className="mt-1 text-sm text-neutral-500">{subheader}</p>
      <a
        href={linkedin}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={`${name} on LinkedIn`}
        className="mt-4 inline-flex h-9 w-9 items-center justify-center rounded-full bg-white ring-1 ring-black/5 transition-transform hover:scale-105"
      >
        <img src="/images/landing-v2/team/linkedin.svg" alt="LinkedIn" className="h-5 w-5" />
      </a>
    </div>
  );
}

export default function TeamSection() {
  return (
    <SectionContainer id="team" className="py-20 sm:py-28">
      <div className="mx-auto max-w-3xl text-center">
        <p className="text-sm font-medium text-neutral-500">Our Team</p>
        <h2 className="mt-3 text-[clamp(1.6rem,3.5vw,2.5rem)] font-semibold leading-[1.15] tracking-tight text-neutral-900">
          The people building Shadow
        </h2>
        <p className="mt-4 text-base text-neutral-600">
          A team from IIT Delhi, IIT Roorkee, and operators from Sanas, Vyapar, and Samsung
          Research — combining deep AI research with real product execution.
        </p>
      </div>

      <div className="mx-auto mt-12 grid max-w-5xl grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {TEAM.map((member) => (
          <TeamCard key={member.name} {...member} />
        ))}
      </div>
    </SectionContainer>
  );
}
